import { useParams } from "react-router-dom";

import { PlayerWrapper } from "../PlayerWrapper";

import "./EmbedPage.scss";

export const EmbedPage = () => {
  const { id } = useParams();

  if (id) {
    return <PlayerWrapper id={id} />;
  } else {
    return <div className="embedPage">
      <p className="error message">Gif id not specified.</p>
    </div>;
  }
};
